import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";
import { theme } from "../../theme/css/theme.css";

export const plainTextAreaStyle = recipe({
  base: {
    lineHeight: 1.5,
    color: theme.colors.onBackground,
  },
  variants: {
    size: {
      default: {
        minHeight: rem(120),
      },
    },
  },
  defaultVariants: {
    size: "default",
  },
});
